import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { catchError, Observable, of, map } from 'rxjs';
import { Router } from '@angular/router';
import { CurrentUserService } from 'src/app/shared/services/current-user.service';

export const superAdminGuard: CanActivateFn = (): Observable<boolean> => {
  const currentUserService = inject(CurrentUserService);
  const router = inject(Router);

  return currentUserService.loadCurrentUser().pipe(
    map((loadSuccess) => {
      if (!loadSuccess) {
        router.navigate(['/home/travel-board']);
        return false;
      }

      const isSuperAdmin = currentUserService.isSuperAdmin();

      if (!isSuperAdmin) {
        router.navigate(['/home/travel-board']);
        return false;
      }

      return true;
    }),
    catchError((err: unknown) => {
      console.error('Error in superAdminGuard:', err);
      router.navigate(['/home/travel-board']);
      return of(false);
    }),
  );
};